import React from 'react'
import ReactDOM from 'react-dom'
import { Card } from '../card'
import { Text } from '../../new/core-components/text'
import { Provider } from '../../ThemeProvider'
import { useTooltipContext } from './TooltipContext'
import { StyledContainer } from './styles'
import { TooltipProps } from './types'

interface Props extends Omit<TooltipProps, 'children'> {
  interactive: boolean
}

const TipComponent = (
  { tip, cardProps, interactive, ...other }: Props,
  ref: React.ForwardedRef<HTMLDivElement>
) => {
  const { isOpen: contextIsOpen } = useTooltipContext()

  const isOpen = contextIsOpen && !!tip

  return ReactDOM.createPortal(
    <StyledContainer
      interactive={interactive}
      opened={isOpen}
      aria-describedby='tooltip'
      ref={ref}
      zIndex={other.zIndex}
    >
      <Provider>
        {isOpen && (
          <Card
            bg='bg/toast'
            color='text/body-major-oncolor'
            p={0}
            px={3}
            py={2}
            cursor={interactive ? undefined : 'default'}
            {...cardProps}
            data-test-id={`Tip-${other['data-test-id']}`}
          >
            {typeof tip === 'string' ? <Text color='text/body-moderate-oncolor'>{tip}</Text> : tip}
          </Card>
        )}
      </Provider>
    </StyledContainer>,
    document.body
  )
}

export const Tip = React.forwardRef(TipComponent)
